module.exports = __webpack_public_path__ + "static/media/external_env_2_media_6.2b96be3e.webp";